module.exports = __webpack_public_path__ + "img/project-details-3.78655300.jpg";